export const DIRECTORY_NAME = 'data-lr-v2-cs-development'
